import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import qs from 'query-string';

import {
  toWeekInt,
  toWeekString,
  toWeekStartDate,
  toWeekEndDate,
  toMonthString,
  toMonthCalendarStartDate,
  toMonthCalendarEndDate,
  toMonthStartDate,
  toMonthEndDate,
} from '../../../helpers/moment';

import WeekView from './WeekView';
import WeekNav from './WeekView/WeekNav';
import MonthView from './MonthView';
import MonthNav from './MonthView/MonthNav';
import { config } from '../../../config/index';
const { API_URL } = config;

const Calendar = ({
  history,
  location: { search },
  schedules,
  activeView,
  activeSchedules,
  activeDate,
  setActiveDate,
  activeWeek,
  setActiveWeek,
  activeMonth,
  setActiveMonth,
  activeClient,
  activeSite,
  shifts,
  todayAttendanceRate,
  attendanceRates,
  todayFillRate,
  fillRates,
  setRefreshCalendar,
  children,
  clickOnceRef,
  siteAssociateLeaves,
  setSidebarMultiAssocLeaves,
  setLoading,
  sites = [],
  selectedSiteID,
}) => {
  const params = qs.parse(search);
  const startDay = activeClient ? activeClient.start_day : 0;
  const token = localStorage.getItem('token');

  const [totalShifts, setTotalShifts] = useState(0);
  const [totalFillRate, setTotalFillRate] = useState(0);
  const [totalAttendanceRate, setTotalAttendanceRate] = useState(0);

  useEffect(() => {
    const fetchTotalAttendance = async () => {
      try {
        let url = `${API_URL}/schedule/attendance/associates`;

        let response = await fetch(url, {
          mode: 'cors',
          method: 'POST',
          body: JSON.stringify({
            site_id: activeSite.id,
            client_id: activeClient.id,
            site_ids:
              Number(selectedSiteID) === 0
                ? sites.map((site) => site.id)
                : [activeSite.id],
            start_date: toWeekStartDate(
              moment(activeDate),
              activeClient.start_day
            ).format('YYYY-MM-DD'),
            end_date: toWeekEndDate(
              moment(activeDate),
              activeClient.start_day
            ).format('YYYY-MM-DD'),
          }),
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          let data = await response.json();
          let associatesData = data.data;

          return associatesData;
        } else {
          console.log(response.message);
        }
      } catch (error) {}
    };

    //set total shifts and total attendance
    const runAsyncFunctions = async () => {
      const attendance = await fetchTotalAttendance();

      setTotalShifts(attendance.totalSlots);
      let percentage = Math.floor(
        (attendance.filledSlots / attendance.totalSlots) * 100
      );
      setTotalFillRate(percentage ? percentage : 0);

      setTotalAttendanceRate({
        rate: isNaN(
          (attendance.totalAttendanceRate / attendance.totalSlots) * 100
        )
          ? 0
          : Math.floor(
              (attendance.totalAttendanceRate / attendance.totalSlots) * 100
            ),
      });
    };

    if (schedules && schedules.length > 0) {
      runAsyncFunctions();
    } else {
      setTotalShifts(0);
      setTotalFillRate(0);
      setTotalAttendanceRate(0);
    }
  }, [schedules]);

  /**
   * Handler functions
   */
  const todayHandler = () => {
    setActiveDate(moment());

    setActiveWeek({
      startDate: toWeekStartDate(moment(), startDay),
      endDate: toWeekEndDate(moment(), startDay),
    });

    // setActiveMonth({
    //   startDate: toMonthStartDate(moment(), startDay),
    //   endDate: toMonthEndDate(moment(), startDay),
    //   calendarStartDate: toMonthCalendarStartDate(moment(), startDay),
    //   calendarEndDate: toMonthCalendarEndDate(moment(), startDay),
    // });

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        date: moment().format('YYYY-MM-DD'),
      }),
    });
  };

  const activeDateHandler = (date) => setActiveDate(date);

  const prevWeekHandler = () => {
    clickOnceRef.current = false;
    setActiveWeek({
      startDate: activeWeek.startDate.clone().subtract('7', 'days'),
      endDate: activeWeek.endDate.clone().subtract('7', 'days'),
    });

    setActiveDate(activeWeek.startDate.clone().subtract('7', 'days'));

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        date: activeWeek.startDate
          .clone()
          .subtract('7', 'days')
          .format('YYYY-MM-DD'),
      }),
    });
  };

  const nextWeekHandler = () => {
    clickOnceRef.current = false;
    setActiveWeek({
      startDate: activeWeek.startDate.clone().add('7', 'days'),
      endDate: activeWeek.endDate.clone().add('7', 'days'),
    });

    setActiveDate(activeWeek.startDate.clone().add('7', 'days'));

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        date: activeWeek.startDate
          .clone()
          .add('7', 'days')
          .format('YYYY-MM-DD'),
      }),
    });
  };

  const prevMonthHandler = () => {
    let updatedMonth = activeMonth.startDate.clone().subtract(1, 'month');

    setActiveMonth({
      startDate: toMonthStartDate(moment(moment(updatedMonth).clone()).clone()),
      endDate: toMonthEndDate(moment(updatedMonth).clone()),
      calendarStartDate: toMonthCalendarStartDate(moment(updatedMonth).clone()),
      calendarEndDate: toMonthCalendarEndDate(moment(updatedMonth).clone()),
    });

    setActiveDate(
      toMonthStartDate(moment(moment(updatedMonth).clone()).clone())
    );

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        date: toMonthStartDate(
          moment(moment(updatedMonth).clone()).clone()
        ).format('YYYY-MM-DD'),
      }),
    });
  };

  const nextMonthHandler = () => {
    let updatedMonth = activeMonth.startDate.clone().add(1, 'month');

    setActiveMonth({
      startDate: toMonthStartDate(moment(updatedMonth).clone()),
      endDate: toMonthEndDate(moment(updatedMonth).clone()),
      calendarStartDate: toMonthCalendarStartDate(moment(updatedMonth).clone()),
      calendarEndDate: toMonthCalendarEndDate(moment(updatedMonth).clone()),
    });

    setActiveDate(toMonthStartDate(moment(updatedMonth).clone()));

    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        date: toMonthStartDate(moment(updatedMonth).clone()).format(
          'YYYY-MM-DD'
        ),
      }),
    });
  };

  /**
   * Render
   */
  let nav = '';
  let view = '';

  if (activeView === 'week') {
    nav = (
      <WeekNav
        activeDate={activeDate}
        activeClient={activeClient}
        activeSite={activeSite}
        activeWeek={activeWeek}
        week={toWeekInt(activeWeek.startDate, startDay)}
        totalShifts={totalShifts}
        totalFillRate={totalFillRate}
        totalAttendanceRate={totalAttendanceRate}
        title={toWeekString(activeWeek.startDate, startDay)}
        today={todayHandler}
        prev={prevWeekHandler}
        next={nextWeekHandler}
        siteAssociateLeaves={siteAssociateLeaves}
        setSidebarMultiAssocLeaves={setSidebarMultiAssocLeaves}
      />
    );

    view = (
      <WeekView
        activeSite={activeSite}
        activeWeek={activeWeek}
        activeDate={activeDate}
        setActiveDate={activeDateHandler}
        setRefreshCalendar={setRefreshCalendar}
        setLoading={setLoading}
      />
    );
  } else {
    nav = (
      <MonthNav
        title={toMonthString(activeMonth.startDate)}
        prev={prevMonthHandler}
        next={nextMonthHandler}
      />
    );

    view = (
      <MonthView
        startDay={startDay}
        activeSchedules={activeSchedules}
        activeDate={activeDate}
        activeMonth={activeMonth}
        shifts={shifts}
        setActiveDate={activeDateHandler}
        todayAttendanceRate={todayAttendanceRate}
        attendanceRates={attendanceRates}
        todayFillRate={todayFillRate}
        fillRates={fillRates}
      />
    );
  }

  return (
    <div className="bg-white adjust-calendar-shadow rounded mb-4 mt-4 border">
      {nav}
      {view}
      {children}
    </div>
  );
};

export default withRouter(Calendar);
